import React from 'react';
import {CloseButton,Flex,Badge, Stack, IconButton,TableContainer,Table,Thead, Tbody,Th,Tr,Td, 
    Box,Alert, AlertTitle, AlertDescription, AlertIcon,  Text, Input, InputLeftElement, InputGroup, 
    Center, Spacer,SkeletonCircle,SkeletonText } from '@chakra-ui/react';
import {SearchIcon} from '@chakra-ui/icons';
import { FiChevronLeft,FiChevronsLeft,FiChevronRight,FiChevronsRight } from "react-icons/fi";
import { useState, useEffect } from 'react';
import {  colorSchmemes } from '../../util/grunt';
import { getOsobeDomace, getOsobe, getOsobeStrane, getOsobeKlaonice,getOsobePosjednikKnjiga } from '../../util/apiOsoba';
import { Osoba } from '../../util/grunt';


const OsobaSelect = ({naslov,onSelect,onClose,subjekttipid="",posjednicinaknjizi=false,showHeader=true,showSearch=true,size='xs', drzavaFilter=""}) => {
    const [state,setState]=useState({filtrosobe:[],osobe:[],errmsg:"",curpage:0,rowsperpage:10, pages:0, filter:""})
    const [isloading,setIsLoading]=useState(true)
    const fetchOsobe=async()=>{
        try {
            let res;
            if (subjekttipid==="") {//sve vrste osoba 'so' i 'os'
                res=await getOsobe({orderbycolumn:"naziv",orderby:"asc"});    
            } else if (subjekttipid==='os') {
                if (posjednicinaknjizi) {
                    res=await getOsobePosjednikKnjiga({orderbycolumn:"naziv",orderby:"asc"});    
                } else {
                    res=await getOsobeDomace({orderbycolumn:"naziv",orderby:"asc"});
                }
                
            } else if (subjekttipid==='so') {
                res=await getOsobeStrane({orderbycolumn:"naziv",orderby:"asc",drzavaSifra:drzavaFilter});
            }
            else if (subjekttipid==="kl"){
                res=await getOsobeKlaonice({orderbycolumn:"naziv",orderby:"asc"});
            }
            
            if (res.status===200) {
                setState({...state,filtrosobe:res.res,osobe:res.res,pages:Math.floor(res.res.length/state.rowsperpage)});        
            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            setState({...state,errmsg:error.message});
        } finally {
            setIsLoading(false);
        }
        
    }

    useEffect(() => {
        fetchOsobe();
    }, []);

    const ShowError=()=>{
        if (state.errmsg!=="") {
            return (
                <Alert status='error'>
                    <AlertIcon />
                    <AlertTitle>Greška kod dohvata podataka</AlertTitle>
                    <AlertDescription>{state.errmsg}</AlertDescription>
                </Alert>
            )
        }
    }
    const ShowOsobe=()=>{
        return(
            <TableContainer>
            <Table size={size}>
                <Thead _hover={{cursor:'pointer'}}>
                    <Tr>
                        <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}>{posjednicinaknjizi?'MIBPG':'Šifra'}</Th>
                        <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Naziv</Th>
                        <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Sjedište</Th>
                        {posjednicinaknjizi?null:<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Država</Th>}
                        
                        
                    </Tr>
                </Thead>
            <Tbody>
                {state.filtrosobe.slice(state.curpage*state.rowsperpage,(state.curpage+1)*state.rowsperpage).map((item,index)=>{
                    
                        return (
                            <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                                    _hover={{bg:'gray.100',cursor:'pointer'}} onClick={(id)=>selectOsoba(item.id)} h='2rem'>
                                        <Td fontSize={size} textAlign={'center'}>{posjednicinaknjizi?item.mibpg:item.sifra}</Td>
                                        <Td fontSize={size} textAlign={'center'}>{item.naziv}</Td>
                                        <Td fontSize={size} textAlign={'center'}>{item.mjesto}</Td>
                                        {posjednicinaknjizi?null:<Td fontSize={size} textAlign={'center'}><Badge size={size} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.drzava_sifra.charCodeAt(0))%16]}>{item.drzava_sifra}</Badge></Td>}
                                    </Tr>
                        )    
                    
                    
                })}
            </Tbody>
            </Table>
            </TableContainer>
        )
    }

    const selectOsoba=(id)=>{
        let _r=state.osobe.find((item)=>{return item.id===id});
        let _o=new Osoba(_r.id,_r.naziv,_r.mjesto,_r.ulkbr,_r.drzava,_r.sifra,_r.posta,_r.pbr,_r.drzava_sifra);
        //onSelect({id:_r.id,naziv:_r.naziv,mjesto:_r.mjesto,ulkbr:_r.ulkbr,drzava:_r.drzava ,adresa:`${_r.mjesto}, ${_r.ulkbr}`,sifra:_r.sifra,posta:`${_r.pbr} ${_r.posta}`})
        onSelect(_o);
    }

    const SetPage=(move)=>{
        let _num=state.curpage;
        switch (move) {
            case "first":
                _num=0;
                break;
            case "previous":
                _num=_num-1;
                break;
            case "next":
                _num=_num+1;
                break;
            default:
                _num=state.pages;
        }
        if (_num<0) {
            _num=0;
        }
        if (_num>state.pages) {
            _num=state.pages;
        }
        setState({...state,curpage:_num});
    }
    const SetFilter=(e)=>{
        const _val=e.target.value;
        let _r=state.osobe.filter((osoba)=>{
            return (osoba.sifra.toLowerCase().includes(_val.toLowerCase()) ||  osoba.naziv.toLowerCase().includes(_val.toLowerCase()) || osoba.mjesto.toLowerCase().includes(_val.toLowerCase()));
        });
        setState({...state,filtrosobe:_r,filter:e.target.value,pages:Math.floor(_r.length/state.rowsperpage),curpage:0});
        
    }
    const getSkeleton=()=>{
        if (isloading) {
          return (
            <Box display={'flex'} flexDir={'column'} flex={1}>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={15} spacing='4' skeletonHeight='4' />
            </Box>
          )
        }
      }
    const buildScreen =()=>{
        if (!isloading) {
            return (
                <>
                    {showHeader?
                    <Flex direction={'row'} color={'white'}  bg={'grunt2.700'} rounded={'sm'}>
                        <Text ml={'0.5rem'} fontWeight={'semibold'}>{naslov}</Text>
                        <Spacer/>
                        <CloseButton size={'sm'} m={'auto'} onClick={onClose}/>
                    </Flex>
                    :null}
                        
                    {showSearch?
                    <InputGroup m={'0.5rem'} size={size}>
                        <InputLeftElement alignContent={'center'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                        <Input focusBorderColor='grunt2.400' variant={'outline'} placeholder={'Filter'} w={'20rem'} onChange={SetFilter}></Input>
                    </InputGroup>  
                    :null}
                    {ShowOsobe()}
                    <Box mt={'0.5rem'}>
                        <Center flexDirection={'row'}>
                        <Stack gap={'0.5rem'} direction={'row'}>
                        <IconButton onClick={(e)=>SetPage('first')}  size={size} variant='outline' colorScheme='grunt2' icon={<FiChevronsLeft />} />
                        <IconButton onClick={(e)=>SetPage('previous')}  size={size} variant='outline' colorScheme='grunt2' icon={<FiChevronLeft />} />
                            <Text>
                            {state.curpage+1} / {state.pages+1}
                            </Text>
                        <IconButton onClick={(e)=>SetPage('next')}  size={size} variant='outline' colorScheme='grunt2' icon={<FiChevronRight />} />
                        <IconButton onClick={(e)=>SetPage('last')}  size={size} variant='outline' colorScheme='grunt2' icon={<FiChevronsRight />} />
                        </Stack>
                        </Center> 
                    </Box>
                </>
            )
        }
    }
    return (
        <Box flexDirection={'column'} fontSize={'sm'} overflow={'hidden'}>
            {getSkeleton()}
            {buildScreen()}
            {ShowError()}
        </Box>
    );
}

export default OsobaSelect;
